import React from 'react';
import {
  HiOutlineDotsVertical,
  HiOutlineEye,
  HiOutlineTrash,
} from 'react-icons/hi';
import { IoMdColorWand } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import {
  Icon,
  Box,
  Flex,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
} from '@chakra-ui/react';

interface CategorieItemProps {
  id: string;
  isCat?: boolean;
  modalFunc?: (type: 'delete' | 'persist') => void;
}

export const DotOptions: React.FC<CategorieItemProps> = ({
  id,
  isCat,
  modalFunc,
}) => {
  const navigate = useNavigate();

  return (
    <Popover>
      <PopoverTrigger>
        <Box
          mt={isCat ? '10px' : '0px'}
          position={isCat ? 'absolute' : 'relative'}
          ml={isCat ? '32px' : 'auto'}
          as="button"
        >
          <Icon color="black" as={HiOutlineDotsVertical} />
        </Box>
      </PopoverTrigger>

      <PopoverContent px="16px" py="12px" maxWidth="120px" bg="white">
        <PopoverArrow />
        <Flex
          onClick={() =>
            navigate(
              isCat
                ? `/centraldeduvidas/lista/${id}`
                : `/centraldeduvidas/pergunta/${id}`,
            )
          }
          as="button"
          alignItems="center"
        >
          <Icon color="button" as={HiOutlineEye} />
          <Text ml="8px" fontSize="14px" textColor="button">
            Exibir
          </Text>
        </Flex>

        <Flex
          onClick={() =>
            isCat
              ? modalFunc?.('persist')
              : navigate(`/centraldeduvidas/pergunta/editar/${id}`)
          }
          mt="8px"
          as="button"
          alignItems="center"
        >
          <Icon color="button" as={IoMdColorWand} />
          <Text ml="8px" fontSize="14px" textColor="button">
            Editar
          </Text>
        </Flex>

        <Flex
          onClick={() =>
            isCat ? modalFunc?.('delete') : modalFunc?.('delete')
          }
          as="button"
          alignItems="center"
          mt="8px"
        >
          <Icon color="red" as={HiOutlineTrash} />
          <Text ml="8px" fontSize="14px" textColor="button">
            Excluir
          </Text>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
